<template>
    <div class="pulse-motiv"></div>
</template>

<script>
    export default {
        props: {
            pulsePlayer: {
                required: true,
                type: String
            },
            pulseId: {
                required: true,
                type: String
            },
        },

        data(){
            return {};
        },

        mounted(){
            let script = document.createElement( 'script' );
            script.setAttribute( 'src', '//insights.pulsemotiv.com/api/pulse_player?pulse=' + this.pulsePlayer );
            script.setAttribute( 'id', this.pulseId );

            this.$el.appendChild( script );
        }
    }
</script>